import { useCallback, useState } from 'react';
import { showAlertModal } from 'utils/modal';
import { WsContentApi } from 'api/ApiHelper';

export const useUploadCoverImage = () => {
  const [isLoading, setIsLoading] = useState(false);

  const uploadImage = useCallback(async (file: File) => {
    const formData = new FormData();
    formData.append('file', file, file.name);

    try {
      setIsLoading(true);
      const { coverImage } = await WsContentApi.uploadCoverFiles(formData);
      return coverImage;
    } catch {
      showAlertModal('이미지 업로드에 실패했어요.');
    } finally {
      setIsLoading(false);
    }
    return undefined;
  }, []);

  return {
    isUploading: isLoading,
    uploadImage,
  };
};
